// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
body.\\--locked {
  overflow: hidden;
}
.app-shell {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100vh;
}
.app-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 48px 32px 32px;
  align-items: center;
}
.app-content__wrap {
  flex: 1 0 auto;
  max-width: 415px;
  width: 100%;
}
.app-content__wrap.\\--wide {
  max-width: 650px;
}
.app-content__wrap.\\--full-width {
  max-width: none;
}
.app-content__wrap.\\--no-navigation-buttons .navigation-button__container {
  display: none;
}
.app-sidebar {
  display: flex;
  flex-direction: column;
  display: none;
  background-color: #00143d;
  color: #fff;
  flex-shrink: 0;
  padding: 24px 32px 32px 32px;
  width: 260px;
}
.app-sidebar__content {
  flex: 1 0 auto;
}
.app-sidebar__logo {
  margin-bottom: 32px;
}
.app-sign-in {
  display: none;
}
@media (min-width: 950px) {
  .app-shell {
    display: flex;
    flex-direction: row;
  }
  .app-shell.\\--header-always-shown {
    display: flex;
    flex-direction: column;
  }
  .app-sidebar {
    display: flex;
    position: fixed;
    top: 0;
    bottom: 0;
    overflow-y: scroll;
  }
  .app-content {
    padding: 96px 32px 32px 292px;
  }
  .app-content.\\--compare {
    padding-top: 50px;
  }
  .app-content.\\--no-sidebar {
    padding: 64px 32px 32px;
  }
  .app-sign-in {
    top: 32px;
    right: 64px;
    display: flex;
    position: absolute;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/dist/bankrate/app-shell.css"],"names":[],"mappings":"AAAA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,gBAAgB;AAClB;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;AACnB;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,cAAc;EACd,4BAA4B;EAC5B,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AAEA;EACE,aAAa;AACf;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,eAAe;IACf,MAAM;IACN,SAAS;IACT,kBAAkB;EACpB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,SAAS;IACT,WAAW;IACX,aAAa;IACb,kBAAkB;EACpB;AACF","sourcesContent":["/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\nbody.\\--locked {\n  overflow: hidden;\n}\n\n.app-shell {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 100vh;\n}\n\n.app-content {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: 48px 32px 32px;\n  align-items: center;\n}\n.app-content__wrap {\n  flex: 1 0 auto;\n  max-width: 415px;\n  width: 100%;\n}\n.app-content__wrap.\\--wide {\n  max-width: 650px;\n}\n.app-content__wrap.\\--full-width {\n  max-width: none;\n}\n.app-content__wrap.\\--no-navigation-buttons .navigation-button__container {\n  display: none;\n}\n\n.app-sidebar {\n  display: flex;\n  flex-direction: column;\n  display: none;\n  background-color: #00143d;\n  color: #fff;\n  flex-shrink: 0;\n  padding: 24px 32px 32px 32px;\n  width: 260px;\n}\n.app-sidebar__content {\n  flex: 1 0 auto;\n}\n.app-sidebar__logo {\n  margin-bottom: 32px;\n}\n\n.app-sign-in {\n  display: none;\n}\n\n@media (min-width: 950px) {\n  .app-shell {\n    display: flex;\n    flex-direction: row;\n  }\n  .app-shell.\\--header-always-shown {\n    display: flex;\n    flex-direction: column;\n  }\n  .app-sidebar {\n    display: flex;\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    overflow-y: scroll;\n  }\n  .app-content {\n    padding: 96px 32px 32px 292px;\n  }\n  .app-content.\\--compare {\n    padding-top: 50px;\n  }\n  .app-content.\\--no-sidebar {\n    padding: 64px 32px 32px;\n  }\n  .app-sign-in {\n    top: 32px;\n    right: 64px;\n    display: flex;\n    position: absolute;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
